"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.function.name.js");
var _ArrowLine = _interopRequireDefault(require("./ArrowLine.vue"));
var _AddNode = _interopRequireDefault(require("./AddNode.vue"));
var _emit = _interopRequireDefault(require("../emit"));
var _constant = require("../constant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-15 09:33:25
 * @Desc: 分支节点
 */
var _default2 = exports.default = {
  name: 'SFCConditionNode',
  components: (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _ArrowLine.default.name, _ArrowLine.default), _AddNode.default.name, _AddNode.default),
  props: {
    nodeList: {
      type: [Array, null],
      default: function _default() {
        return null;
      }
    },
    data: {
      type: Object,
      default: null
    },
    isMouseEnter: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: _constant.store.readonly,
      vertical: _constant.store.vertical
    };
  },
  methods: {
    onAddConditionBranchClick: function onAddConditionBranchClick() {
      _emit.default.emit('add-condition-branch-click', this.data);
    }
  }
};